/**
 * Complete list of 60 Political Parties supported on Amalgamate
 */
export const POLITICAL_PARTIES = [
  "Action Party",
  "Agrarian Party",
  "Alliance Party",
  "Centre Party",
  "Christian Party",
  "Christian Democratic Party",
  "Christian People’s Party",
  "Civic Party",
  "Civic Democratic Party",
  "Communist Party",
  "Conservative Party",
  "Constitution Party",
  "Democratic Party",
  "Democratic Labour Party",
  "Democratic People’s Party",
  "Democratic Socialist Party",
  "Equality Party",
  "Fascist Party",
  "Fatherland Party",
  "Free Democratic Party",
  "Freedom Party",
  "Green Party",
  "Independence Party",
  "Justice Party",
  "Labour Party",
  "Left Party",
  "Liberal Party",
  "Liberal Democratic Party",
  "Libertarian Party",
  "Liberty Party",
  "Moderate Party",
  "Motherland Party",
  "National Party",
  "National Action Party",
  "National Democratic Party",
  "National Liberal Party",
  "National People’s Party",
  "National Unity Party",
  "New Alliance Party",
  "New Democratic Party",
  "People’s Party",
  "People’s Action Party",
  "Pirate Party",
  "Popular Party",
  "Progressive Party",
  "Progressive Democratic Party",
  "Radical Party",
  "Reform Party",
  "Republican Party",
  "Republican People’s Party",
  "Revolutionary Party",
  "Social Democratic Party",
  "Social Liberal Party",
  "Socialist Party",
  "Socialist Labour Party",
  "Socialist Workers Party",
  "Unionist Party",
  "United Democratic Party",
  "Unity Party",
  "Workers’ Party"
];

export default POLITICAL_PARTIES;
